/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_Open_ImagesInputs */

const en_advantages_sample_open_images = /** @type {(inputs: Advantages_Sample_Open_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This formulation helps when we move to more complex domains like the Open Images Dataset`)
};

const es_advantages_sample_open_images = /** @type {(inputs: Advantages_Sample_Open_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta formulación ayuda cuando nos movemos a dominios más complejos como el conjunto de datos Open Images`)
};

/**
* | output |
* | --- |
* | "This formulation helps when we move to more complex domains like the Open Images Dataset" |
*
* @param {Advantages_Sample_Open_ImagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_open_images = /** @type {((inputs?: Advantages_Sample_Open_ImagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_Open_ImagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_open_images(inputs)
	return en_advantages_sample_open_images(inputs)
});